import React from 'react';
import './Spinner.css';

const Spinner = () => {
  return (
    <div className="rotating-spinner">
      <div className="circle"></div>
    </div>
  );
};

export default Spinner;